export { default as CatalogoMotivoPadrao } from './apresentacao/CatalogoMotivoPadrao.vue'
export { usarCatalogoMotivoPadrao } from './apresentacao/usar-catalogo-motivo-padrao'
export { CHAVE_OPERACOES_CATALOGO_MOTIVO_PADRAO, usarOperacoesCatalogoMotivoPadrao } from './apresentacao/catalogo-motivo-padrao.injecao'
export { DESCRITOR_CATALOGO_MOTIVO_PADRAO } from './catalogo-motivo-padrao.tipos'
export type {
  CampoDinamicoMotivoPadrao,
  FiltrosCatalogoMotivoPadrao,
  OpcaoMotivoPadrao,
  OperacoesCatalogoMotivoPadrao,
  SelecaoCatalogoMotivoPadrao,
} from './catalogo-motivo-padrao.tipos'
